const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M252.2,115.7c-37.4-55.4-78.8-83.2-124.2-83.2S42.7,59.2,5.9,112.6l-2.1,3-.8,1.3c-4.2,7.3-3.9,16.3.8,23.3,37.4,55.4,78.8,83.2,124.2,83.2s85.3-26.7,122.1-80.1l2.1-3,.8-1.3c4.2-7.3,3.9-16.3-.8-23.3ZM231.9,131c-33,47.9-67.5,70.5-103.9,70.5s-70.9-22.6-103.9-70.5l-2-3,2-3C57.1,77.2,91.6,54.6,128,54.6s70.9,22.6,103.9,70.5l2,3-2,3Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,81.2c-26.4.3-47.8,21.7-48.1,48.1-.3,26.9,21.2,49,48.1,49.3.4,0,.8,0,1.2,0,26.9-.3,48.4-22.4,48.1-49.3-.3-26.9-22.4-48.4-49.3-48.1ZM128,156.6c-.3,0-.6,0-.9,0-14.7-.2-26.5-12.4-26.2-27.1.2-14.7,12.4-26.5,27.1-26.2,14.4.2,26,11.8,26.2,26.2.2,14.7-11.5,26.9-26.2,27.1Z",
    style: {
      fill: "#f22",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.0ef948074ae4c3e30e6feb4bc0aa2055.svg";
export { ForwardRef as ReactComponent };